export default class WizardState {
    constructor() {
        this.currentStep = 0;
        this.isActive = false;
        this.isPaused = false;
        this.completedSteps = new Set();
        this.userInteractions = new Map();
        this.sectionStates = new Map();
    }

    setSectionState(sectionId, isOpen) {
        this.sectionStates.set(sectionId, isOpen);
    }

    getSectionState(sectionId) {
        return this.sectionStates.get(sectionId) || false;
    }

    reset() {
        this.currentStep = 1;
        this.isActive = true;
        this.isPaused = false;
        this.completedSteps.clear();
        this.userInteractions.clear();
    }

    complete() {
        this.isActive = false;
        this.currentStep = 0;
        localStorage.setItem('wizardCompleted', 'true');
    }

    skip() {
        this.isActive = false;
        this.currentStep = 0;
        localStorage.setItem('wizardSkipped', 'true');
    }

    pause() {
        this.isPaused = true;
    }

    resume() {
        this.isPaused = false;
    }
}
